export var UIEvent;
(function (UIEvent) {
    UIEvent["ContentSizeChanged"] = "content_size_changed";
    UIEvent["ControllersChanged"] = "controllers_changed";
    UIEvent["Scroll"] = "scroll";
    UIEvent["ScrollEnd"] = "scroll_end";
    UIEvent["PullDownRelease"] = "pull_down_release";
    UIEvent["PullUpRelease"] = "pull_up_release";
    UIEvent["ClickItem"] = "click_item";
    UIEvent["Popup"] = "popup";
    UIEvent["InstanceReload"] = "instance_reload";
})(UIEvent || (UIEvent = {}));
